// extracted by mini-css-extract-plugin
export default {"header":"header__2NfmI","companyNameText":"companyNameText__G2YEr","saveButton":"saveButton__L173B"};